import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function RankingSection() {
  const ranking = [...comics].sort((a, b) => b.rating - a.rating).slice(0, 10);

  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16 bg-background-100/60">
      <div className="mb-8">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
          评分排行
        </h2>
        <p className="text-sm text-foreground-500 mt-1.5">读者评分最高的漫画作品</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {ranking.map((comic, index) => (
          <Link
            key={comic.id}
            to={`/comic/${comic.id}`}
            className="flex items-center gap-4 p-3 rounded-lg bg-background-50 hover:bg-background-100 transition-colors cursor-pointer group"
          >
            <div className="flex items-center gap-1 min-w-[36px]">
              {index < 3 ? (
                <span className={`w-7 h-7 flex items-center justify-center rounded-full text-sm font-bold ${
                  index === 0
                    ? 'bg-accent-500 text-background-50'
                    : index === 1
                    ? 'bg-amber-400 text-background-50'
                    : 'bg-amber-300 text-background-50'
                }`}>
                  {index + 1}
                </span>
              ) : (
                <span className="w-7 h-7 flex items-center justify-center text-sm font-semibold text-foreground-400">
                  {index + 1}
                </span>
              )}
            </div>
            <img
              src={comic.cover}
              alt={comic.title}
              className="w-12 h-16 rounded object-cover flex-shrink-0"
              loading="lazy"
            />
            <div className="flex-1 min-w-0">
              <h4 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors truncate">
                {comic.title}
              </h4>
              <p className="text-xs text-foreground-500 mt-0.5">{comic.author}</p>
              <div className="flex items-center gap-3 mt-1">
                <span className="text-xs text-accent-500 font-semibold">{comic.rating}分</span>
                <span className="text-xs text-foreground-400">
                  {comic.views > 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views} 阅读
                </span>
              </div>
            </div>
            <span className={`px-2 py-0.5 text-xs rounded-full ${
              comic.status === '连载中' ? 'bg-accent-100 text-accent-900' : 'bg-secondary-100 text-secondary-900'
            }`}>
              {comic.status}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}